import _ from 'lodash';

var Data = {
    optionizeString: function (str) {
        return {value: str, label: str};
    },
    optionizeStringFormatValue: function (str) {
        return {value: str.replace(/\s+/g, '_').toUpperCase(), label: str};
    },
    keyedCopyInsert: function (collection, item, idx, key) {
        item.key = key;
        collection = collection.slice(0);
        collection.splice(idx, 0, item);
        return collection;
    },
    keyedEditOrUnshift: function (collection, item, key) {
        collection = _.isArray(collection) ? collection.slice() : [];
        if (item.key >= 0) {
            collection.splice(_.findIndex(collection, {key: item.key}), 1, item);
        } else {
            item.key = key;
            collection.unshift(item);
        }
        return collection;
    },
    deleteAtIndex: function (collection, idx) {
       collection = collection.slice(0);
       collection.splice(idx, 1);
       return collection;
    },
    removeKey: function (item) {
        delete item.key;
        return item;
    },
    trim: function (event) {
        if (event) {
            event.target.value = _.trim(event.target.value);
        }
    }
};

export default Data;
